import { CompanyMonitoringAlertCategoryEnum } from '../../../../shared/models';
import yup from '../../../../utils/yup-extended';
import { CompanyMonitoringCheckInput } from '../company-monitoring-check-input';

export const companyMonitoringSettingsSchema = (): yup.SchemaOf<
  CompanyMonitoringCheckInput['settings']
> => {
  return yup
    .object()
    .shape({
      alertCategories: yup
        .array()
        .of(
          yup
            .string()
            .oneOf(Object.values(CompanyMonitoringAlertCategoryEnum))
            .required()
            .defined() as yup.BaseSchema<
            CompanyMonitoringAlertCategoryEnum,
            unknown,
            CompanyMonitoringAlertCategoryEnum
          >,
        )
        .uniqueItems()
        .strict()
        .nullable()
        .optional(),
      // Need to re-cast otherwise there is an error
      // Type 'BaseSchema<CompanyMonitoringAlertCategoryEnum, unknown, CompanyMonitoringAlertCategoryEnum>' is not assignable to type 'BaseSchema<"financial_changes", AnyObject, "financial_changes">'
    })
    .noUnknown()
    .defined() as yup.SchemaOf<CompanyMonitoringCheckInput['settings']>;
};
